import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '/',
    children: [
      {
        name: 'login',
        path: '/login',
        component: () => import('@login/views/LogInScreen.vue'),
        meta: {
          breadcrumb: 'login'
        }
      },
      {
        name: 'check-email',
        path: '/check-email',
        component: () => import('@login/views/CheckEmailScreen.vue'),
        meta: {
          breadcrumb: 'check-email'
        },
        beforeEnter: (_, from, next) => {
          if (['login', 'youandco'].every(routeName => routeName !== from.name)) {
            next({ name: 'login' })
            return
          }
          next()
        }
      },
      {
        name: 'set-password',
        path: '/set-password',
        component: () => import('@login/views/SetNewPasswordScreen.vue'),
        meta: {
          breadcrumb: 'set-password'
        }
      },
      {
        name: 'points',
        path: '/points',
        component: () => import('@points/views/PointsView.vue'),
        meta: {
          breadcrumb: 'points'
        }
      },
      {
        name: 'transactions',
        path: '/transactions',
        component: () => import('@transactions/views/TransactionsScreen.vue'),
        meta: {
          breadcrumb: 'transactions'
        }
      },
      {
        name: 'finance',
        path: '/finance',
        component: () => import('@/features/finance/views/FinanceView.vue'),
        meta: {
          breadcrumb: 'finance',
          permission: 'view_finance'
        }
      },
      {
        name: 'youandco',
        path: '/youandco',
        component: () => import('@youandco/views/YouAndCoView.vue'),
        meta: {
          breadcrumb: 'youandco'
        }
      }
    ]
  }
]

export default routes
